const applicationRouter = {
  path: '',
  component: () => import('@/layout'),
  children: [
    {
      path: '/businessLicense',
      name: 'BusinessLicense',
      meta: { title: '网上营业执照' },
      component: () => import(/* webpackChunkName: "application" */ '@/pages/businessLicense')
    },
    {
      path: '/entry', // 外国人入境申请表
      name: 'Entry',
      meta: { title: '外国人入境申请表' },
      component: () => import(/* webpackChunkName: "application" */ '@/pages/welcomeToYiwu/entry')
    },
    {
      path: '/subsidies', // 外商/华侨来义采购行宿补贴申请表
      name: 'Subsidies',
      meta: { title: '外商/华侨来义采购行宿补贴申请表' },
      component: () =>
        import(/* webpackChunkName: "application" */ '@/pages/welcomeToYiwu/subsidies')
    }
  ]
}

export default applicationRouter
